import HabilidadService from 'src/modules/habilidad/habilidadService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'HABILIDAD_VIEW';

const habilidadViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: habilidadViewActions.FIND_STARTED,
      });

      const record = await HabilidadService.find(id);

      dispatch({
        type: habilidadViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: habilidadViewActions.FIND_ERROR,
      });

      getHistory().push('/habilidad');
    }
  },
};

export default habilidadViewActions;
